import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { filter, map, mergeMap, switchMap, take, takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/components/base/base.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { missionsTrx } from 'src/app/router-translation.labels';
import { isPlatformServer } from '@angular/common';
import { Mission } from 'src/app/services/missions/missions.models';
import { MissionService } from 'src/app/services/missions/mission.service';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { timer } from 'rxjs';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-all-mission',
  templateUrl: './all-mission.component.html',
  styleUrls: ['./all-mission.component.scss']
})
export class AllMissionComponent extends BaseComponent {
  tournments: Mission[] = [];
  missionAll: Mission[] = [];
  missionsTrx = '/' + missionsTrx;
  isLogged: boolean;
  constructor(
    @Inject(PLATFORM_ID) private platformId,
    private missionService: MissionService,
    private loginStatus: LoginStatusService,
    private prevUrlService: DialogClosePreviousUrl,
    public licenceService: LicenceService,
  ) {
    super();
  }

  isServer: boolean;
  isLoading = false;
  status: any = 'all';

  ngOnInit(): void {
    this.isServer = isPlatformServer(this.platformId);
    this.isLoading = true;
    this.missionService.getInAppTournamentMetaData().pipe(take(1)).subscribe((resp) => {
      this.setSEOTags(resp.seo?.metaTitle, resp.seo?.metaDescription, resp.seo?.relCanonical)
    })
    this.getTournament();
  }

  getTournament() {
    this.loginStatus.getLoginStatus().pipe(
      filter(status => status.isLogged !== LoggedStatus.voidState),
      switchMap((status) => {
        return this.missionService.updateMissionsStore().pipe(
          map(tournaments => ({ tournaments, isLogged: status.isLogged === LoggedStatus.logged }))
        )
      }),
      takeUntil(this.unsubscribe)
    ).subscribe(resp => {
      this.isLogged = resp.isLogged;
      this.isLoading = false;
      console.log('login status', resp);
      // this.numberTournaments = resp.length;
      if (!this.isLogged) {
        resp.tournaments = resp.tournaments.filter(x => !x.isPrizeEngineEligiblePlayers)
      }
      this.tournments = resp.tournaments;
      this.missionAll = resp.tournaments;
      console.log(this.tournments)

      timer(100).pipe(take(1)).subscribe(() => {
        this.prevUrlService.getUrl().pipe(take(1)).subscribe(path => {
          if (path?.includes(missionsTrx) && path.length == 2) {
            window.scrollTo(0, this.prevUrlService.getScrollPosition())
          }
        })
      })
    });
  }

  filterTour(status: any) {
    this.status = status;
    let allTour = this.missionAll;
    if (status != 'all')
      this.tournments = allTour.filter(x => x.missionType == this.status)
    else
      this.tournments = allTour;

    console.log('filter', this.tournments)
  }


}
